/**
 * @generated SignedSource<<de84f4664d90d31b45611e208197b216>>
 * @relayHash 5dceed141e0b10467703b6bc2c2dcf88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f311289b7f26105b438dd34eea17073cd275a39182aa2ba60a6ec3f2785a8776

import type { ConcreteRequest } from 'relay-runtime';
export type PageUpdateTrigger = "CREATE_PAGE" | "DISCARD_CHANGES" | "EDIT_PAGE" | "LINK_REFACTORING" | "MIGRATE_PAGE_COLLAB" | "OWNER_CHANGE" | "PAGE_RENAME" | "PERSONAL_TASKLIST" | "REVERT" | "SPACE_CREATE" | "UNKNOWN" | "VIEW_PAGE" | "%future added value";
export type TaskStatus = "CHECKED" | "UNCHECKED" | "%future added value";
export type InlineTasksInput = {
  cid: string;
  status: TaskStatus;
  taskId: string;
  trigger?: PageUpdateTrigger | null;
};
export type SetTaskStatusSuccessMutation$variables = {
  input: InlineTasksInput;
};
export type SetTaskStatusSuccessMutation$data = {
  readonly setTaskStatus: {
    readonly success: boolean;
  } | null;
};
export type SetTaskStatusSuccessMutation = {
  response: SetTaskStatusSuccessMutation$data;
  variables: SetTaskStatusSuccessMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "inlineTasksInput",
        "variableName": "input"
      }
    ],
    "concreteType": "GraphQLMutationResponse",
    "kind": "LinkedField",
    "name": "setTaskStatus",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SetTaskStatusSuccessMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetTaskStatusSuccessMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5dceed141e0b10467703b6bc2c2dcf88",
    "id": "f311289b7f26105b438dd34eea17073cd275a39182aa2ba60a6ec3f2785a8776",
    "metadata": {},
    "name": "SetTaskStatusSuccessMutation",
    "operationKind": "mutation",
    "text": "mutation SetTaskStatusSuccessMutation($input:InlineTasksInput!){setTaskStatus(inlineTasksInput:$input){success}}"
  }
};
})();

(node as any).hash = "1a562120f26888ee72e438dd6a1ccb9f";

export default node;
